<prt-template [today]="today">

	@if (isViewTypeAP) {
	<div class="row justify-content-center">
		<table class="wrapper-print-table fitbone-implant-measures">
			<th class="d-none"></th>
			<tbody>
				<tr>
					<td><strong>{{labels().IMPLANT}}:</strong> {{implant}} ({{ fitboneLength }} mm)</td>
					<td><strong>{{ targetBoneLengthLbl }}:</strong> {{ maLength }}</td>
					@if (mLDFA) {
					<td><strong>{{labels().MLDFA}}:</strong> {{mLDFA}}°</td>
					}
					@if (MPTA) {
					<td><strong>{{labels().MA_AP_TABLE_COMPONENT_MPTA}}:</strong> {{MPTA}}°</td>
					}
					@if (axisCorrection) {
					<td><strong>{{labels().AXIS_CORRECTION}}:</strong> {{axisCorrection}}</td>
					}
					@if (femurAxialRotation) {
					<td><strong>{{labels().ROTATION_CORRECTION}}:</strong> {{ femurAxialRotation }}</td>
					}
					@if (tibiaAxialRotation) {
					<td><strong>{{labels().ROTATION_CORRECTION}}:</strong> {{ tibiaAxialRotation }}</td>
					}
					@if (osteotomyLevel) {
					<td><strong>{{labels().OSTEOTOMY}}:</strong> {{ osteotomyLevel }} mm</td>
					}
				</tr>
			</tbody>
		</table>
	</div>
	}
	<div class="row justify-content-center position-relative">
		@if (isViewTypeAP) {
		<hr class="prt-fitbone-line" [style.top.px]="lineOffset">
		<hr class="prt-fitbone-line" [style.top.px]="FHPropAPlineOffset">
		<hr class="prt-fitbone-line" [style.top.px]="CAPropAPlineOffset">
		}
		<img [src]="defAnalysSrc" class="w-auto" width="434" height="1749" alt="defAnalysSrc" />
		<img [src]="fitboneCloseSrc" class="w-auto" width="434" height="1749" alt="fitboneCloseSrc" />
		<img [src]="fitboneOpenSrc" class="w-auto" width="434" height="1749" alt="fitboneOpenSrc" />
	</div>

</prt-template>